type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

type UserLike = {
  firstName?: string;
  lastName?: string;
  email?: string;
  isDeleted?: boolean;
} | null | undefined;

export const getDisplayUserLabel = (user: UserLike, t: TranslateFn) => {
  if (user?.isDeleted) {
    return t('common.userRemoved');
  }

  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim();
  if (fullName) {
    return fullName;
  }

  if (user?.email) {
    return user.email;
  }

  return t('common.userRemoved');
};
